import './App.css';

import { Routes, Route } from "react-router-dom";
import FAQ from './components/faq/faq';
import Layout from './components/layout/layout';
import Recommended from './components/recommended/recommended';
import Prepare from './components/prepare/prepare';
import TermsOfUse from './components/terms-of-use/terms-of-use';
import PrivacyPolicy from './components/privacy-policy/privacy-policy';
import BkcHome from './components/bkchome/bkchome';
import { useLocation } from "react-router-dom";
import { isNullOrEmpty } from "./lib/helper";
import createServices from './services/ioc/service-creator';
import { ServicesProvider } from './services/ioc/service-dependency';


function App() {
  
  let pathname = "";
  var location = useLocation();
  if (!isNullOrEmpty(location)) {
      pathname = location.pathname;
  }

  const services = createServices(pathname);
  return (
      <ServicesProvider services={services}>
        <Routes>
          <Route path="/" element={<Layout pathname={pathname} />}>
            <Route index element={<Prepare pathname={pathname} />} />
            <Route path="faq" element={<FAQ pathname={pathname} />} />
            <Route path="/:culture/faq" element={<FAQ pathname={pathname} />} />
            <Route path="/:culture/:location/faq" element={<FAQ pathname={pathname} />} />
            <Route path="bkcapp" element={<BkcHome pathname={pathname} />} />
            <Route path="/:culture/bkcapp" element={<BkcHome pathname={pathname} />} />
            <Route path="/:culture/:location/bkcapp" element={<BkcHome pathname={pathname} />} />
            <Route path="recommended" element={<Recommended pathname={pathname} />} />
            <Route path="/:culture/recommended" element={<Recommended pathname={pathname} />} />
            <Route path="/:culture/:location/recommended" element={<Recommended pathname={pathname} />} />
            <Route path="/:culture/*" element={<Prepare pathname={pathname} />} />
            <Route path="/:culture/:location/*" element={<Prepare pathname={pathname} />} />
            <Route path="*" element={<Prepare pathname={pathname} />} />
            <Route path="terms-of-use" element={<TermsOfUse />} />
            <Route path="/:culture/terms-of-use" element={<TermsOfUse />} />
            <Route path="/:culture/:location/terms-of-use" element={<TermsOfUse />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/:culture/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/:culture/:location/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="bkcappnewlayout" element={<BkcHome pathname={pathname} />} />
            <Route path="/:culture/bkcappnewlayout" element={<BkcHome pathname={pathname} />} />
            <Route path="/:culture/:location/bkcappnewlayout" element={<BkcHome pathname={pathname} />} />
          </Route>
        </Routes>
      </ServicesProvider>
  );
}

export default App;
